import instrukta from '../../assets/images/instruckta.svg';

import './header.css';

export default function Header() {
    return (
        <div className="header">
            <img src={instrukta} alt="iNSTRUCKTA!" />
        </div>
    );
}
